import { BAR } from "src/components/Charts/types";
import { Question, ReportObject, Survey } from "./models";
import { strategies } from "./question/strategies";

export class ModelToPayloadParser {
  static parse(surveyId, questionConfig, reportConfig, originalQuestionData) {
    const configObject = ModelToPayloadParser._buildConfigPayload(reportConfig);
    const questionList =
      ModelToPayloadParser._buildQuestionPayload(questionConfig);

    const reportData = ModelToPayloadParser._buildReportData(
      originalQuestionData,
      questionConfig
    );

    const partialPayload = ModelToPayloadParser._buildPayload(
      configObject,
      questionList
    );

    return {
      surveyId: surveyId,
      ...partialPayload,
      questions: [...reportData],
    };
  }

  static _buildReportData(originalQuestionData, questionConfig) {
    if (typeof originalQuestionData !== "object") {
      return [];
    }
    const parsedOriginalData = [];

    for (let i = 0; i < originalQuestionData.length; i++) {
      const originalQuestion = originalQuestionData[i];
      const matchedQuestion = questionConfig[originalQuestion.id];
      if (!!matchedQuestion) {
        const originalQuestionTemp = {
          ...originalQuestion,
        };

        const originalIndex =
          parsedOriginalData.push({ ...originalQuestionTemp }) - 1;

        const currentParsedOriginalData = {
          ...parsedOriginalData[originalIndex],
        };

        originalQuestion.dados_plotagem_relatorio.forEach((data, index) => {
          const currentMatchedQuestion = {
            ...matchedQuestion,
            graficos: [...matchedQuestion.graficos],
          };

          currentMatchedQuestion.graficos = matchedQuestion.graficos.filter(
            (q) => q.tipo === data.resultado_type_def
          );

          const questionParseStrategy = strategies[data.resultado_type_def];

          // Por enquanto somente grafico de barra do card simples tem ordenação
          const simpleChart = matchedQuestion.graficos.find(g => g.tipo === "GERAIS");

          const barChartOrder = simpleChart && simpleChart.render === BAR
            ? simpleChart.order || 'DESC'
            : 'DESC';

          if (typeof questionParseStrategy === "function") {
            const chartPlotData = questionParseStrategy(
              data,
              currentMatchedQuestion,
              barChartOrder
            );

            currentParsedOriginalData.dados_plotagem_relatorio[index] =
              chartPlotData ? { ...chartPlotData } : null;
          }
        });
      }
    }

    const dadosFiltradosSemNull = parsedOriginalData.map((obj) => ({
      ...obj,
      dados_plotagem_relatorio: obj.dados_plotagem_relatorio.filter(
        (value) => !!value
      ),
    }));

    return dadosFiltradosSemNull;
  }

  static _buildPayload(configObject, questionList) {
    return {
      ...configObject,
      questions: questionList,
    };
  }

  static _buildQuestionPayload(questionConfig) {
    return Object.entries(questionConfig).map((item) => {
      const [id, question] = item;
      return new Question(id, question.enunciado);
    });
  }

  static _buildCustomizationObject(coverImageUrl) {
    const customization = {
      cover_image_url: coverImageUrl || null,
    }
    return customization;
  }

  static _buildConfigPayload(reportConfig) {
    const {
      pageTitle,
      clientName,
      sample,
      field_period,
      error_margin,
      trust,
      method,
      considerations,
      coverImageUrl,
    } = reportConfig;

    const surveyParams = new Survey(
      sample,
      field_period,
      error_margin,
      trust,
      method,
      considerations
    );

    const customizationObject = ModelToPayloadParser._buildCustomizationObject(coverImageUrl);

    return new ReportObject(pageTitle, surveyParams, clientName, customizationObject);
  }
}
